import React, { Children, cloneElement, forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { StyledUiCard } from './UiCard.styles';

const UiCard = (props, ref) => {
  const { className, header, body, footer, children, ...restProps } = props;
  return (
    <StyledUiCard
      className={classNames('ui-card', className)}
      {...restProps}
      ref={ref}
    >
      {header && (
        <header className={classNames('ui-card-header', header.className)}>
          {header.element && header.element}
        </header>
      )}
      {body && (
        <main className={classNames('ui-card-body', body.className)}>
          {body.element && body.element}
        </main>
      )}
      {footer && (
        <footer className={classNames('ui-card-footer', footer.className)}>
          {footer.element && footer.element}
        </footer>
      )}
      {Children.map(children, (child) => {
        const componentName = child?.props?.component;
        if (!componentName) {
          return child;
        }

        let className = 'ui-card-body';
        if (componentName === 'CardHeader') {
          className = 'ui-card-header';
        } else if (componentName === 'CardFooter') {
          className = 'ui-card-footer';
        }
        return cloneElement(child, {
          className: classNames(child.props.className, className),
        });
      })}
    </StyledUiCard>
  );
};

UiCard.propTypes = {
  className: PropTypes.string,
  header: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object,
  children: PropTypes.any,
};

export default forwardRef(UiCard);
